{
  "slug": "",
  "content": "welcome",
  "title": "Welcome",
  "children": [
    {
      "devOnly": true,
      "slug": "test",
      "title": "Markdown examples",
      "content": "testpage.md"
    },
    {
      "slug": "changelog",
      "title": "Changelog",
      "content": "changes"
    },
    {
      "slug": "projects",
      "title": "Projects",
      "content": "projects"
    },
    {
      "slug": "rooms",
      "title": "Rooms",
      "content": "rooms"
    },
    {
      "devOnly": true,
      "slug": "airflow",
      "title": "Airflow zones",
      "content": "zones"
    }
  ]
}
